<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

import { usePublicData } from '@/stores/PublicData'
import { useAccountStore } from '@/stores/Account'

import EditorSettings from '@/components/editor/EditorSettings.vue'
import EditorSettingsBackgroundTheme from '@/components/editor/EditorSettingsBackgroundTheme.vue'
import EditorSettingsBackgroundIcon from '@/components/editor/EditorSettingsBackgroundIcon.vue'
import { LANGUAGES, type LanguageType } from '@/api/interfaces'

const { t } = useTranslate('local')
const publicStore = usePublicData()
const accountStore = useAccountStore()

const items = {
  ...LANGUAGES.reduce(
    (acc, lang) => {
      acc[lang] = []
      return acc
    },
    {} as Record<LanguageType, []>,
  ),
  en: [
    {
      title: t.value('EditorBackgroundSettings.theme.title'),
      component: EditorSettingsBackgroundTheme,
    },
    {
      title: t.value('EditorBackgroundSettings.icon.title'),
      description: t.value('EditorBackgroundSettings.icon.description'),
      component: EditorSettingsBackgroundIcon,
      disabled: accountStore.hasStarterPlan,
    },
  ],
}
</script>

<template>
  <EditorSettings :items="items[publicStore.lang]" :title="t('EditorBackgroundSettings.title')" />
</template>

<style lang="scss" scoped></style>
